import type { FaireProductEntity } from "../../entity_types/product";

export const p_9nbdxk85md: FaireProductEntity = {
  token: "p_9nbdxk85md",
  type: "product",
  name: "Festival® 18-inch Windchime - Wholesale",
  brandToken: "b_8z7zv9rr",
  brandName: "Wind River",
  imageUrl:
    "https://cdn.faire.com/fastly/d078aed419f2e7974e21f3d384cfb7a0dea48ef1c421fcf19242663b4785f463.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cb2872389ec9dc6765cc027fa8bcd46eb15ecba98d3593d5ad55d839766a6843.jpeg",
    "https://cdn.faire.com/fastly/e31bc7f936514a1846684127fba9896987eb18bdead2c6e9e2b69f98594ae928.jpeg",
    "https://cdn.faire.com/fastly/f9a929e59b6e1119170d39680bf0f0324216e0b110523fab8422358b4b54b525.jpeg",
    "https://cdn.faire.com/fastly/342e2e3aa4978459411e4b34c788cd45581033dbbebb49258c6d54dfda042972.jpeg",
    "https://cdn.faire.com/fastly/2b6aa01c79f1c72c79917dedea9e1eb058d294558fdcbf5e108aa1d7f4528e4d.jpeg",
  ],
  priceDollars: 29.6,
  description:
    "\nHandcrafted in the U.S.A., and available in three eye-catching colors, this windchime is the perfect accent piece for any balcony, patio, or garden. The smallest Festival®  chime, it brightens your day with its light song and looks good anywhere.\n",
  tags: [],
  msrpDollars: 62.15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:59.377Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
